import React from 'react';
import { Send } from 'lucide-react';
import { Button } from '../ui/button';

/**
 * Company lookup input for existing customers
 */
const ChatCompanyLookup = ({ value, onChange, onSubmit }) => {
  return (
    <div className="fixed bottom-0 left-0 right-0 bg-white/80 backdrop-blur-xl border-t border-gray-200/50 animate-in slide-in-from-bottom duration-500">
      <div className="max-w-4xl mx-auto px-6 py-4">
        <form onSubmit={onSubmit} className="flex gap-3">
          <input
            type="text"
            value={value}
            onChange={(e) => onChange(e.target.value)}
            placeholder="Bedrifts e-post eller organisasjonsnummer..."
            className="flex-1 border-2 border-gray-300 focus:border-gray-400 rounded-xl px-5 py-4 focus:outline-none focus:ring-2 focus:ring-gray-200 transition-all bg-white shadow-sm"
            autoFocus
          />
          
          <Button
            type="submit"
            disabled={!value.trim()}
            className="bg-gradient-to-r from-indigo-600 to-blue-600 hover:from-indigo-700 hover:to-blue-700 px-8 py-4 h-auto rounded-xl shadow-sm hover:shadow-lg transition-all disabled:opacity-50"
          >
            <Send className="w-5 h-5" />
          </Button>
        </form>
        
        <p className="text-xs text-gray-500 mt-2 text-center">
          Vi sjekker om bedriften allerede er registrert
        </p>
      </div>
    </div>
  );
};

export default ChatCompanyLookup;
